import React from 'react';
import { EyeColorType } from '@avaturn/sdk';

const eyeColors: EyeColorType[] = [
  'amber',
  'blue',
  'blue_gray_yellow',
  'brown',
  'dark_brown',
  'gray',
  'gray_green',
  'green',
  'light_gray',
  'light_green',
];

interface EyeColorPickerProps {
  selectedColor: EyeColorType;
  onChange: (color: EyeColorType) => void; // 외부에서 핸들러를 전달받음
}

const EyeColorPicker: React.FC<EyeColorPickerProps> = ({
  selectedColor = 'brown',
  onChange,
}) => {
  // 파일명 변환 (예: "gray_green" → "Gray_Green.webp")
  const formatFileName = (color: EyeColorType) =>
    color
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .replace(/ /g, '_');

  const handleColorSelect = (color: EyeColorType) => {
    if (color !== selectedColor) {
      console.log(color);
      onChange(color); // 부모 컴포넌트에서 가져온 핸들러 호출
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        backgroundColor: '#12131A',
        padding: '10px',
        borderRadius: '10px',
        overflowX: 'auto',
      }}
    >
      <strong style={{ color: 'white', fontSize: '16px' }}>Eye Color</strong>
      {/* 구분선 */}
      <div style={{ width: '2px', height: '24px', backgroundColor: '#555' }} />

      <div style={{ display: 'flex', gap: '8px' }}>
        {eyeColors.map((color) => {
          const fileName = formatFileName(color);
          return (
            <div
              key={color}
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '50%',
                overflow: 'hidden',
                cursor: 'pointer',
                border:
                  selectedColor === color
                    ? '2px solid yellow'
                    : '2px solid transparent',
                transition: '0.2s',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              onClick={() => handleColorSelect(color)}
            >
              <img
                src={`/eyecolors/${fileName}.webp`}
                alt={color}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  clipPath: 'circle(15% at center)', // 중앙 10% 영역만 보이게 설정
                  transform: 'scale(5)', // 10배 확대하여 중앙이 보이도록 조정
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EyeColorPicker;
